import {
  XA_FETCH_DOWNLOADINFO_POST,
  XA_FETCH_DOWNLOADINFO_SUCCESS,
  XA_FETCH_DOWNLOADINFO_FAILURE,
  XA_FETCH_AGENTS_POST,
  XA_FETCH_AGENTS_SUCCESS,
  XA_FETCH_AGENTS_FAILURE,
  XA_DELETE_AGENT_POST,
  XA_DELETE_AGENT_SUCCESS,
  XA_DELETE_AGENT_FAILURE,
} from '../../actions/xAgent';

const INITIAL_STATE = {
  loadingDownloadInfo: true,
  loadingAgents: true,
  error: null,
};

export default function xAgentLoadingStateReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case XA_FETCH_DOWNLOADINFO_POST:
      return {
        loadingDownloadInfo: true,
        loadingAgents: state.loadingAgents,
        error: null,
      };
    case XA_FETCH_AGENTS_POST:
    case XA_DELETE_AGENT_POST:
      return {
        loadingDownloadInfo: state.loadingDownloadInfo,
        loadingAgents: true,
        error: null,
      };
    case XA_FETCH_DOWNLOADINFO_SUCCESS:
      return {
        loadingDownloadInfo: false,
        loadingAgents: state.loadingAgents,
        error: null,
      };
    case XA_FETCH_AGENTS_SUCCESS:
    case XA_DELETE_AGENT_SUCCESS:
      return {
        loadingDownloadInfo: state.loadingDownloadInfo,
        loadingAgents: false,
        error: null,
      };
    case XA_FETCH_DOWNLOADINFO_FAILURE:
    case XA_FETCH_AGENTS_FAILURE:
    case XA_DELETE_AGENT_FAILURE:
      return {
        loadingDownloadInfo: false,
        loadingAgents: false,
        error: {
          message: action.payload,
        },
      };
    default:
      return state;
  }
}
